import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, pluck } from 'rxjs/operators';

import { EventBusMessage } from '../models/event-bus-message.model';

@Injectable()
export class EventBusService implements OnDestroy {

  private tunnel$: Subject<EventBusMessage> = new Subject();
  tunnelObservable$: Observable<EventBusMessage> = this.tunnel$.asObservable();

  emit<P = {}>(message: EventBusMessage<P>): void {
    this.tunnel$.next(message);
  }

  on<P = {}>(expectedEvent: string): Observable<P> {
    return this.tunnelObservable$
      .pipe(
        filter((event: EventBusMessage) => event.kind === expectedEvent),
        pluck<EventBusMessage, P>('payload'),
      );
  }

  ngOnDestroy(): void {
    this.tunnel$.complete();
  }
}
